export default __webpack_public_path__ + "static/media/SHORT-OFF.0b48c995.png";